import React, { useState } from "react";
import styles from './.FilterBoxComponents.module.css';
import emailFilterStyles from './ContactEmailFilter.module.css';

const JobTitleFilter = ({ jobTitles, setJobTitles, seniorities, setSeniorities }) => {
    const [jobTitleInput, setJobTitleInput] = useState('');
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);

    const jobTitleSuggestions = [
        "ceo","chief executive officer","founder","co-founder","owner","chief operating officer","coo","chief financial officer","cfo","chief technology officer","cto","chief marketing officer","cmo",
      ];
    const handleJobTitleInputChange = (event) => {
        const input = event.target.value;
        setJobTitleInput(input);
        // Filter suggestions based on input
        if (input.trim() !== "") {
          const filtered = jobTitleSuggestions.filter((title) =>
            title.toLowerCase().includes(input.toLowerCase())
          );
          setFilteredSuggestions(filtered);
          setShowDropdown(filtered.length > 0);
        } else {
          setShowDropdown(false);
        }
      };
      const handleJobTitleInputKeyDown = (event) => {
        if (event.key === "Enter" && jobTitleInput.trim() !== "") {
            const newTitle = jobTitleInput.trim();
            // Convert all existing titles to lowercase for comparison
            if (!jobTitles.some((title) => title.toLowerCase() === newTitle.toLowerCase())) {
                setJobTitles([...jobTitles, newTitle]);
            } else {
                // Replace existing title with the new casing
                setJobTitles(jobTitles.map(title =>
                    title.toLowerCase() === newTitle.toLowerCase() ? newTitle : title
                ));
            }
            setJobTitleInput(""); // Clear input field
            setShowDropdown(false);
            event.preventDefault();
        }
    };
    const handleSelectSuggestion = (title) => {
        // Convert all existing titles to lowercase for comparison
        if (!jobTitles.some((t) => t.toLowerCase() === title.toLowerCase())) {
            setJobTitles([...jobTitles, title]);
        } else {
            // Replace existing title with the new casing
            setJobTitles(jobTitles.map(t =>
                t.toLowerCase() === title.toLowerCase() ? title : t
            ));
        }
        setJobTitleInput(""); // Clear input
        setShowDropdown(false);
    };
    const removeJobTitle = (indexToRemove) => {
    setJobTitles(jobTitles.filter((_, index) => index !== indexToRemove));
    };

    const seniorityOptions = [
      "C suite",
      "Vp",
      "Director",
      "Manager",
    ]
    const handleSenioritiesChange = (event) => {
        const { value, checked } = event.target;
        setSeniorities((prevValues) =>
          checked
            ? prevValues.includes(value)
              ? prevValues
              : [...prevValues, value]
            : prevValues.filter((item) => item !== value)
        );
      }
  
    return (
 
<div className={styles.accordionContent} >
<label>Title</label>
<input
  type="text"
  placeholder="Enter job title or select..."
  value={jobTitleInput}
  onChange={handleJobTitleInputChange}
  onKeyDown={handleJobTitleInputKeyDown}
  className={styles.filterInput}
/>

{/* Suggestions Dropdown */}
{showDropdown && (
  <ul className={styles.dropdown}>
    {filteredSuggestions.map((title, index) => (
      <li key={index} onClick={() => handleSelectSuggestion(title)} className={styles.dropdownItem}>
        {title}
      </li>
    ))}
  </ul>
)}

{/* Selected Job Titles */}
<div className={styles.selectedSection}>
  {jobTitles.map((title, index) => (
    <div key={index} className={styles.selectedChip}>
      {title}
      <button onClick={() => removeJobTitle(index)} className={styles.buttonX}>
        ×
      </button>
    </div>
  ))}
</div>
{/*
<label>Seniority</label>
  <div className={emailFilterStyles.emailCheckboxContainer}>
  {seniorityOptions.map((option, index) => (
    <label>
      <div className={emailFilterStyles.checkBoxRow} key={index}>
        <input
            type="checkbox"
            value={option}
            checked={seniorities.includes(option)}
            onChange={handleSenioritiesChange}
            className={emailFilterStyles.emailCheckbox}
            // style={{ marginRight: "10px" }}
        />
        <div>{option}</div>
      </div>
    </label>
  ))}
  </div>
*/}
</div>
)};
 
export default JobTitleFilter;